import CaliforniaPage from '../../StatePages/CaliforniaPage';
import OklahomaPage from '../../StatePages/OklahomaPage';
import TexasPage from '../../StatePages/TexasPage';
import GenericLanding from '../GenericLanding';
import UtahLanding from '../UtahLanding';
import UAELanding from '../UAELanding';

interface LandingPageParams {
  [country: string]: RegionParam | Param;
}

interface RegionParam {
  [region: string]: Param;
}

export interface Param {
  [param: string]: string;
}

interface LandingPageComponent {
  variant: string | null;
  page: JSX.Element;
}

export const landingPageParams: LandingPageParams = {
  'United States': {
    Utah: {
      param: '?variant=100',
    },
    California: {
      param: '?variant=110',
    },
    Texas: {
      param: '?variant=120',
    },
    Oklahoma: {
      param: '?variant=130',
    },
  },
  Algeria: {
    param: '?variant=200',
  },
  Bahrain: {
    param: '?variant=200',
  },
  Egypt: {
    param: '?variant=200',
  },
  Iran: {
    param: '?variant=200',
  },
  Iraq: {
    param: '?variant=200',
  },
  Israel: {
    param: '?variant=200',
  },
  Jordan: {
    param: '?variant=200',
  },
  Kuwait: {
    param: '?variant=200',
  },
  Lebanon: {
    param: '?variant=200',
  },
  Libya: {
    param: '?variant=200',
  },
  Morocco: {
    param: '?variant=200',
  },
  Oman: {
    param: '?variant=200',
  },
  Palestine: {
    param: '?variant=200',
  },
  Qatar: {
    param: '?variant=200',
  },
  'Saudi Arabia': {
    param: '?variant=200',
  },
  Syria: {
    param: '?variant=200',
  },
  Tunisia: {
    param: '?variant=200',
  },
  'United Arab Emirates': {
    param: '?variant=200',
  },
  Yemen: {
    param: '?variant=200',
  },
};

export const landingPageComponents: LandingPageComponent[] = [
  {
    variant: null,
    page: <GenericLanding />,
  },
  {
    variant: '100',
    page: <UtahLanding />,
  },
  {
    variant: '110',
    page: <CaliforniaPage />,
  },
  {
    variant: '120',
    page: <TexasPage />,
  },
  {
    variant: '130',
    page: <OklahomaPage />,
  },
  {
    variant: '200',
    page: <UAELanding />,
  },
];
